import axios from 'axios';
import _ from 'lodash';
import dayjs from 'dayjs';
import qs from 'qs';
import { OrderStatuses } from '@tradingblock/types';
import axiosRetry from 'axios-retry'; // export function toApiResponse<D>(resp: ApiResponse<D> | LegacyApiResponse<D>): ApiResponse<D> {
//   const payload: D = _.get(resp, 'Payload', undefined) || _.get(resp, 'payload', undefined);
//   const responseCode: ResponseCode = _.get(resp, 'ResponseCode', undefined) || _.get(resp, 'responseCode', undefined);
//   return {
//     payload,
//     responseCode,
//   };
// }

var clients = {};
export var createAxiosClient = function createAxiosClient(url, token) {
  // Check if we already have a client instance for this url and token
  if (clients["".concat(url, "-").concat(token)] !== undefined) {
    return clients["".concat(url, "-").concat(token)];
  }

  var client = axios.create({
    baseURL: url,
    headers: {
      Authorization: token,
      Accept: 'application/json'
    }
  });
  axiosRetry(client, {
    retries: 3,
    retryCondition: function retryCondition(e) {
      // Don't retry on 429 (rate limit) to prevent compounding the issue
      return axiosRetry.isNetworkOrIdempotentRequestError(e) && e.response && e.response.status !== 429;
    },
    shouldResetTimeout: true,
    retryDelay: function retryDelay(retryCount, error) {
      if (error.response && error.response.headers !== undefined) {
        var retry_after = error.response.headers['retry-after'];
        console.log('Retrying after: ', retry_after);

        if (retry_after) {
          return retry_after * 1000;
        }
      } // Exponential backoff with jitter to prevent thundering herd


      var baseDelay = Math.min(1000 * Math.pow(2, retryCount), 10000); // Cap at 10 seconds

      var jitter = Math.random() * 1000; // Add up to 1 second of jitter

      return baseDelay + jitter;
    },
    onRetry: function onRetry(retryCount, error, requestConfig) {
      console.log("Retry attempt #".concat(retryCount, " for ").concat(requestConfig.url));
      console.log("Error ", error);
    }
  }); //Create a cache version of clients to prevent multiple clients from being created

  clients["".concat(url, "-").concat(token)] = client;
  return client;
};
export var formatUrl = function formatUrl(url, querystringParams) {
  var delim = url.indexOf('?') > -1 ? '&' : '?';
  var params = querystringParams ? qs.stringify(querystringParams, {
    arrayFormat: 'comma'
  }) : null;
  return "".concat(url).concat(params ? delim + params : '');
};
export function isString(x) {
  return typeof x === 'string';
}
export function getIdNumber(id) {
  return _.toNumber(id);
}
export var DateFormats = {
  ApiFormat: 'MM-DD-YYYY',
  DateTimeApiFormat: 'YYYY-MM-DD hh:mm:ss'
};
export var dateStringOrUndefined = function dateStringOrUndefined(dateOrString, format) {
  //if (dateOrString === undefined || isString(dateOrString)) return dateOrString;
  var dateValue = dateOrString === undefined || isString(dateOrString) ? dayjs(dateOrString).toDate() : dateOrString;

  if (format === undefined) {
    return dayjs(dateValue).toDate().toISOString();
  }

  return dayjs(dateValue).format(format);
};
export function isInfinity(val) {
  return val === 'Infinity';
}
export function isHeartbeat(val) {
  return val.type === 'HeartBeat';
}
export function isExpiredToken(val) {
  return val.type === 'ExpiredToken';
}
export function isOrderUpdate(val) {
  return val.type === 'OrderUpdate';
}
export function isQuote(val) {
  return val.type === 'Quote';
}
export function isSpread(val) {
  return val.type === 'Spread';
}
export function isSettlement(val) {
  return val.type === 'Settlement';
}
export function getOrderStatus(val) {
  var match = _.map(OrderStatuses, function (s, k) {
    return {
      status: k,
      value: s
    };
  }).find(function (v) {
    return v.value === val;
  });

  return match;
}
export function isCashieringUpdate(val) {
  return val.type === 'CashieringUpdate';
}
export function isAccountApplicationUpdate(val) {
  return val.type === 'AccountApplicationUpdate';
}
export function isOpenPriceUpdate(val) {
  return val.type === 'OpenPriceUpdate';
}